import React from 'react';
import { Button as ButtonComponent } from 'decentraland-ui/dist/components/Button/Button';
import NetworkCheck from '../NetworkCheck';
const disabledStyle = { opacity: 0.5, cursor: 'not-allowed', transform: 'none' };
export default class NetworkButton extends React.PureComponent {
    render() {
        const { network, onClick, ...rest } = this.props;
        return (React.createElement(NetworkCheck, { network: network }, isEnabled => {
            const props = isEnabled ? { onClick } : { style: disabledStyle };
            return React.createElement(ButtonComponent, { ...rest, ...props });
        }));
    }
}
//# sourceMappingURL=NetworkButton.js.map